import axios from 'axios'
import router from '@/router'
import {service} from './api.js';
import {urlPrefix,getLocalItem} from './common.js';
// import baseUrl from "./baseUrl";
import Vue from 'vue'
import {Toast} from 'vant';
Vue.use(Toast);
let token = '';
let instance = axios.create({
    // baseURL:baseUrl,
    baseURL: "",
    timeout:600000,
    withCredentials: true,
});
// 请求头加token
axios.defaults.headers.common['token'] = token;
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['clientid'] = "041fd3cdf170f4104baf5a15621344cc";
export const gettimedate=(data)=> {
    let value = data.getFullYear() + '-' +
        checkTime(data.getMonth() + 1) + '-' +
        checkTime(data.getDate()) + ' ' +
        checkTime(data.getHours()) + ':' +
        checkTime(data.getMinutes()) + ':' +
        checkTime(data.getSeconds());
    return value
}
export const checkTime=(i)=> {
    if (i < 10) {
        i = "0" + i
    }
    return i;
}
export const Http = {}; // 包裹请求方法的容器
// 请求格式/参数的统一
for(let key in service){
    let api = service[key]; // url method

    // async 作用：避免进入回调地狱
    Http[key] = async function(
        params, // 请求参数 get：url，put，post，patch（data），delete：url
        isFormData= api.isFormData?api.isFormData:false,// 标识是否是form-data请求
        configParmas={} // 配置参数
    ){
        // if(api.isFormData){
        //     axios.defaults.headers['Content-Type'] = 'multipart/form-data';
        // }
        let newParams = {}
        //  content-type是否是form-data的判断
        if(params && isFormData){
            newParams = new FormData()
            for(let i in params){
                newParams.append(i,params[i])
            }
        }else{
            newParams = params
        }
        // 不同请求的判断
        let response = {}; // 请求的返回值
        if(api.method === 'post'|| api.method === 'put'){
            try{
                if(api.noTrans) {
                    let postParams = new URLSearchParams();
                    for(let i in newParams) {
                        postParams.append(i,newParams[i]);
                    }
                    response =  await instance[api.method](urlPrefix[api.site]+api.url,postParams,configParmas)
                } else {
                    response =  await instance[api.method](urlPrefix[api.site]+api.url,newParams,configParmas)
                }
            }catch(err){
                response = err
            }
        }else if(api.method === 'delete'|| api.method === 'get'){
            configParmas.params = newParams
            try{
                // console.log('newParams',newParams)
                // console.log('configParmas',configParmas)
                response =  await instance[api.method](urlPrefix[api.site]+api.url,configParmas)
            }catch(err){
                response = err
            }
        }
        return response; // 返回响应值
    }
}
instance.interceptors.request.use(config=>{
    // 发起请求前做些什么
    //window.localStorage.getItem("accessToken") 获取token的value
    let token = getLocalItem('accessToken');
    let user_info = getLocalItem('user_login_info')
    if (token) {
        //将token放到请求头发送给服务器,将tokenkey放在请求头中
        config.headers.common['token'] = token;
        if(user_info){
            let lastTime = user_info.lastActiveTime;//上一次登录时间
            let curentTime = new Date().getTime();
            let nowTime = new Date();
            // console.log('上次登录时间：'+gettimedate(new Date(lastTime)))
            // console.log('当前时间：'+gettimedate(nowTime))
            // if (curentTime >= lastTime) {
            // axios({
            //     method: 'post',
            //     url: 'http://192.168.10.77:8080/vis/mobile/basedata/myTask/getMyOrderList',
            //     data: {
            //         agentnum: "B120211937",
            //         carlicenseno: "",
            //         insuredname: "",
            //         limit: 10,
            //         offset: 0,
            //         orderstatus: "1",
            //         search: false,
            //         taskcreatetimedown: "",
            //         taskcreatetimeup: "",
            //     },
            //     headers: {
            //         'Content-Type': 'application/json;charset=utf-8',
            //     },
            // }).then((res)=>{
            //     console.log(res)
            // });
            // }
        }else{
            if(router.history.current.name != 'login'){
                router.replace({
                    path: '/login' // 到登录页重新获取token
                });
            }
        }

        return config;
    }
    return config
},(error)=>{
    return Promise.reject(error);
    // 请求错误
    // Toast('请求错误!');
})
// 响应拦截器
instance.interceptors.response.use(response=>{
    // token过期的操作暂未写完
    //
    // 请求成功
    return response.data;
},(error)=>{
    let tips;
    if(error&&error.response) {
        switch(error.response.status){
            case 400:
                tips = '错误请求-'+error.response.status;
                break;
            case 401:
                tips = '未授权，请重新登录-'+error.response.status;
                break;
            case 403:
                tips = '拒绝访问-'+error.response.status;
                break;
            case 404:
                tips = '错误请求，未找到该资源-'+error.response.status;
                break;
            case 405:
                tips = '请求方法未允许-'+error.response.status;
                break;
            case 408:
                tips = '请求超时-'+error.response.status;
                break;
            case 500:
                tips = '服务器端出错-'+error.response.status;
                break;
            case 501:
                tips = '网络未实现-'+error.response.status;
                break;
            case 502:
                tips = '网络错误-'+error.response.status;
                break;
            case 503:
                tips = '服务不可用-'+error.response.status;
                break;
            case 504:
                tips = '网络超时-'+error.response.status;
                break;
            case 505:
                tips = 'http版本不支持该请求-'+error.response.status;
                break;
            default:
                tips = `连接错误${error.response.status}`;
                break;
        }
    } else{
        tips = '网络出现问题，请稍候重试';
    }
    Toast.fail(tips);
})
